import React, { useContext } from "react";
import CardApplicationAPI from "../../api/commercial/card-application";
import { LanguageContext } from "../../context/languageContext";
import {
  ApplicationFlows,
  ApplicationFlowSteps,
} from "../../route/application/authenticated/application-flow/types";
import { ErrorContext } from "../../route/error/provider";
import GTM from "../../util/tracking/gtm";
import CardholderBasicInformation from "./index";
import CardholderBasicMapper from "./mapper";
import { CardholderLocalState, CardholderPageModel } from "./types";
import ProductContextHelper from "../../context/product-context/helper";
import { ProductRefType } from "../../context/product-context/types";

export default function CardholderBasicInformationLocalStateAdapter({
  localState,
  triggerReload,
}: {
  localState: CardholderLocalState;
  triggerReload: () => void;
}): React.JSX.Element {
  const {
    productRef,
    basicAccountApplicationRef,
    companyName,
    isSoleProprietorship,
    limit,
  } = localState;

  const { setError } = useContext(ErrorContext);
  const { language } = useContext(LanguageContext);

  GTM.trackVirtualPageView(
    ApplicationFlowSteps.CARDHOLDER,
    ProductContextHelper.productRefToProduct(productRef),
    language,
  );

  return (
    <CardholderBasicInformation
      inLocalState={true}
      flowType={ApplicationFlows.ADDITIONAL_CA}
      context={{
        companyName,
        selectedProduct: productRef as ProductRefType,
        isSoleProprietorship,
        hasDecentralizedInvoicing: localState.hasDecentralizedInvoicing,
        limit,
      }}
      previous={() => {
        triggerReload();
      }}
      next={async (model: CardholderPageModel) => {
        const cardApplicationRequest =
          CardholderBasicMapper.mapPageModelToRequest(model, productRef);
        try {
          await CardApplicationAPI.startAdditionalCardApplication(
            cardApplicationRequest,
            basicAccountApplicationRef,
          );
        } catch (e) {
          setError(e);
        }

        triggerReload();
      }}
    />
  );
}
